import React, { memo, useMemo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, errors, currentOrg,
}) {
  const sessionFilter = useMemo(
    () => ({ org: currentOrg }),
    [currentOrg],
  );
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.DateInput
          value={row.datefrom}
          onChange={(e, v) => actions.onChange(e, row.id, { datefrom: v })}
          readOnly={fields.datefrom.read_only || readOnly}
          errors={errors && errors.datefrom}
        />
      </TableCell>
      <TableCell>
        <TableControls.ItemPicker
          value={row.session_decision}
          onChange={(e, v) => actions.onChange(e, row.id, { session_decision: v })}
          readOnly={fields.session_decision.read_only || readOnly || !currentOrg}
          errors={errors && errors.session_decision}
          backend={fields.session_decision.resource}
          filter={sessionFilter}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number,
    datefrom: PropTypes.string,
    dateto: PropTypes.string,
    session_decision: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
  }).isRequired,
  fields: PropTypes.shape({
    datefrom: PropTypes.shape({ read_only: PropTypes.bool }),
    dateto: PropTypes.shape({ read_only: PropTypes.bool }),
    session_decision: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  errors: PropTypes.shape({
    datefrom: PropTypes.arrayOf(PropTypes.string),
    dateto: PropTypes.arrayOf(PropTypes.string),
    session_decision: PropTypes.arrayOf(PropTypes.string),
  }),
  currentOrg: PropTypes.number,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  errors: null,
  currentOrg: null,
};

export default memo(Row);
